// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"styles_iconButton__ri7S5","iconButton__link":"styles_iconButton__link__5y22U"};